import Vue from 'vue'

const shareddata = {
  alerts:{
      login:{
              alert:'',
              variant:'success',
              time: 2
              },
      logout:{
              alert:'Logging Out',
              variant:'warning',
              time: 2
              },
      resetemail:{
              alert:'Password Reset Email Sent',
              variant:'success',
              time: 3
              },
      resetfailed:{
              alert:'Reset Failed!',
              variant:'danger',
              time: 3
              },
      resetsuccess:{
              alert:'Password Reset!',
              variant:'success',
              time: 4
              },
      activated:{
              alert:'Successfully Activated!',
              variant:'success',
              time: 3
              },
      alreadyactivated:{
              alert:'Already Activated',
              variant:'warning',
              time: 3
              },
      activationerror:{
              alert:'Activation Error',
              variant:'danger',
              time: 3
              },
    activationsent:{
        alert:"We've sent you a message to confirm your email!",
        variant:'success',
        time:4
    },
    updated:{
        alert:'Updated!',
        variant:'success',
        time:2
      },

    voucher:{
        alert:'Voucher Applied!',
        variant:'success',
        time:2
      },
   imageupdated:{
        alert:'Image Updated!',
        variant:'success',
        time:2
      },
    },
  app_theme:{
      AGM:{
      LOGO:'https://taskfilescsm.s3-eu-west-1.amazonaws.com/uploads/speaker_thumb/logo.png',
      HOMEPAGE_IMAGE:"url('https://taskfilescsm.s3-eu-west-1.amazonaws.com/uploads/speaker_thumb/iStock-1150350319-3.jpg')",
      HOMEPAGE_TITLE:'Welcome to the Acute & General Medicine<br>Learning Archive',
      HOMEPAGE_SUBTITLE:'Get access to over 300+ hours of CPD videos',
      AREA_ALIAS:'Specialty',
      DEFAULT_COLOR:'#831f82',
      JOIN_TEXT_ONE:'On demand, watch anytime, anywhere.',
      JOIN_TEXT_TWO:'World class instructors from top clinics around the globe.',
      JOIN_TEXT_THREE:'Earn credits online with downloadable certificates.',
      GALLERY_ALIAS:'Learning Archive',
      JOIN_HEADER:'Get the Best, From the Best'
  },
      TECHERATI:{
      LOGO:'https://academycsm.s3-eu-west-1.amazonaws.com/media/Techerati+PNG.png',
      HOMEPAGE_IMAGE:"url('https://academycsm.s3-eu-west-1.amazonaws.com/darkened.png')",
      HOMEPAGE_TITLE:'Welcome to Techerati Academy',
      HOMEPAGE_SUBTITLE:'Get access to hundreds of hours of videos and webinars, on-demand',
      AREA_ALIAS:'Area',
      DEFAULT_COLOR:'#44C8F5',
      JOIN_TEXT_ONE:'On demand, watch anytime, anywhere.',
      JOIN_TEXT_TWO:'World class instructors from top clinics around the globe.',
      JOIN_TEXT_THREE:'Earn credits online with downloadable certificates.',
      GALLERY_ALIAS:'Courses',
      JOIN_HEADER:'Get the Best, From the Best'
  }
  },
}


const shared = {
  install(Vue,options){
   Vue.prototype.$globalConstants = shareddata
  }
}

export { shared }



// WEBPACK FOOTER //
// ./src/globalConfig.js